
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMegamenuGoogle as ObiMegamenuGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-megamenu-google.js';
 
 
 

 
 export const ObiMegamenuGoogle = createComponent({
   react: React,
   tagName: 'obi-megamenu-google',
   elementClass: ObiMegamenuGoogleElement,
   events: {
     
   }
  });
 
 